import React, { Component } from 'react'

import { Auth } from "aws-amplify";
import './style.css'
import AuthLayout from './AuthLayout';

export class LoginOTPForm extends Component{
  constructor(props) {
    super(props)

    console.log(props.errorMesssage)
  }

  render() {
    return (
      <AuthLayout>
        <p style={{ marginTop: 0, paddingBottom: 16 }}>We have delivered the authentication code by SMS to {this.props.user.challengeParam.CODE_DELIVERY_DESTINATION}. Please enter the code to complete authentication.</p>
        <p className="a-errorMessage" hidden={this.props.errorMesssage.length <= 0}>The code entered is invalid, please try again.</p>
        <form className="auth-form">
          <input
            className="auth-input"
            type="text"
            placeholder="Enter verification code"
            name="verificationCode"
            required
            onChange={this.props.handleChange}
          />
          <button type="submit" className="auth-btn-primary" onClick={this.props.confirmSignIn}>
            Sign In
          </button>
        </form>
      </AuthLayout>
    )
  }
}

export default LoginOTPForm
